export default "__VITE_ASSET__387b6c02__"